import { render } from "./BaladoTestimonial.vue?vue&type=template&id=87690248"
import script from "./BaladoTestimonial.vue?vue&type=script&lang=js"
export * from "./BaladoTestimonial.vue?vue&type=script&lang=js"
script.render = render

export default script